import React ,{useState} from "react"
import {useNavigate,useParams} from "react-router-dom"
import {toast} from "react-toastify"
import UserImage from "../assets/user.png"
import {api } from "../app/Api/ApiSlice"


const OrgFriendAccept = ({user}) => {
    const navigate = useNavigate()
    const [loadingAccept,setLoadingAccept] = useState(false)
    const [loadingRemove,setLoadingRemove] = useState(false)

    const {organization} = useParams()

    const acceptRequest = async()=>{
        try{
            setLoadingAccept(true)
            const response = await api.post(`/${organization}/friends`,{friend:user._id})
            if(response){
                setLoadingAccept(false)
                toast.success(response.data.message)
            }
        }catch(error){
            setLoadingAccept(false)
            toast.error(error.response.data.message)
        }
    }
    const removeRequest = async()=>{
        try{
            setLoadingRemove(true)
            const response = await api.patch(`/${organization}/friends`,{friend:user._id})
            if(response){
                setLoadingRemove(false)
                toast.success(response.data.message)
            }
        }catch(error){
            setLoadingRemove(false)
            toast.error(error.response.data.message)
        }
    }

  return (
    <div className="action-user-card">
        <div className="action-card-user-data">
            <img  src={user.profilePic?user.profilePic.url:UserImage} alt="" />
            <div className= "action-user-card-details">
                <p>{user.firstname} {user.lastname}</p>
                <div className="user-card-actions-btns">
                    <button onClick={acceptRequest}>{loadingAccept?"Loading...":"Add"}</button>
                    <button onClick={removeRequest}>{loadingRemove?"Loading...":"Remove"}</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default OrgFriendAccept;